import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'
import { Slide } from 'react-reveal'

import Icon from '../../../../components/ui/Icon/Icon'
import LinkButton from '../../../../components/ui/LinkButton/LinkButton'

import Loader from '../../../../assets/img/loader.gif'
import MoreHeaderParticles from '../../../../assets/img/more-header-particles.svg'
import RightSideBarHeader from '../../../../assets/img/right-sidebar-header.svg'

import * as LoyaltyApiService from '../../../../services/api/requests/Loyalty'
// import * as GCashApiService from '../../../../services/api/requests/GCash'
import dateFormat from '../../../../services/data/dateFormat'
import gCashStatus from '../../../../services/data/gCashStatus'

import {
  MAIN,
  // ADD_CARD,
  UPDATE_PROFILE,
} from '../../../../services/data/profilePages.json'
import ActionButton from '../../../../components/ui/ActionButton/ActionButton'
import GCashV2 from '../../../../assets/img/gcash/gcash-logo-v2.svg'
import GCashWord from '../../../../assets/img/gcash/gcash-word.svg'
import GCashModal from '../../../../components/home/GCashModal/GCashModal'

const MainPage = styled.div`
  display: ${props => (props.show ? 'flex' : 'none')};
  flex-direction: column;
  overflow: hidden;
  height: 100%;

  &::before {
    content: ' ';
    display: block;
    height: 244px;
    background-color: var(--color-primary);
    background: url('${RightSideBarHeader}'), url('${MoreHeaderParticles}'), linear-gradient(var(--color-primary), var(--color-primary));
    background-position: bottom, right top;
    background-repeat: no-repeat;
    background-size: 100%, auto;
    flex: 0 0 244px;
  }
`

const Header = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  flex: 0 0 auto;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  min-height: 87px;
  font-size: 0.7rem;
`

const ReturnIcon = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  border-radius: 2rem;
  cursor: pointer;
  font-size: 0.92rem;
  margin-left: 20px !important;
  margin-right: 20px !important;
  color: var(--color-fg-light);
  background: rgba(255, 255, 255, 0.5);
  z-index: 1;

  & > svg {
    position: relative;
    color: #ffffff;
  }
`

const Title = styled.h1`
  font-family: var(--font-family-ayala-display-sans);
  flex: 1;
  padding: 20px 0;
  margin: 0;
  margin-right: 60px;
  color: #ffffff;
  font-size: 1.125rem;
  font-weight: var(--font-weight-boldest);
  text-transform: uppercase;
  text-align: center;
`

const DetailHeader = styled.div`
  position: relative;
  height: 270px;
  background: linear-gradient(rgba(141,122,157,0.40), rgba(141,122,157,0.40)), linear-gradient(180deg,rgba(0,0,0,0.00) 30%,#2C2F3A 100%), url('${props =>
    props.background}'), linear-gradient(#000000, #000000);
  background-size: cover;
`

const HeaderDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 4rem 2rem;
  text-align: center;
`

const Merchant = styled.h2`
  color: #ffffff;
  font-size: 1.25rem;
  font-weight: var(--font-weight-boldest);
  line-height: 1.5625rem;
  margin: 0;
  margin-bottom: 0.625rem;
`

const TagLine = styled.p`
  color: #ffffff;
  font-size: 0.875rem;
  font-weight: var(--font-weight-boldest);
  line-height: 1.3125rem;
  margin: 0;
`

const DetailReturnIcon = styled(ReturnIcon)`
  position: absolute;
  top: 1.8125rem;
`

const ErrorHeader = styled.div`
  position: relative;
  display: flex;
  flex: 0 0 auto;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  min-height: 87px;
  font-size: 0.7rem;
  background: var(--color-primary);

  &::before {
    content: ' ';
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: url('${MoreHeaderParticles}');
    background-repeat: no-repeat;
    background-position: right top;
  }
`

const Content = styled.div`
  height: 100%;
  padding: 0;
  overflow: auto;
  padding-bottom: 40px;
  box-sizing: border-box;
`

const TabWrapper = styled.div`
  display: flex;
  border: 1px solid #ebebeb;
  border-radius: 5px;
  margin: 1rem;
  margin-top: -2rem;
  background: #ffffff;
`

const Tab = styled.a`
  padding: 0.9375rem;
  cursor: pointer;
  flex: 1;
  text-align: center;
  font-size: 0.875rem;
  font-weight: var(--font-weight-boldest);
  color: var(--color-primary);
  letter-spacing: 1px;
  opacity: ${props => (props.active ? '1' : '0.5')};

  &:hover {
    opacity: 0.8;
  }
`

const ListItem = styled.div`
  display: flex;
  height: 96;
  padding: 1rem;
  margin: 1rem;
  border: 1px solid #ebebeb;
  border-radius: 5px;
  cursor: pointer;

  &:first-child {
    margin-top: 0;
  }
`

const DetailWrapper = styled.div`
  flex: 1;
  margin-right: 1rem;
  min-width: 0;
`

const ItemIcon = styled.div.attrs(props => ({
  style: {
    background: `url('${props.background}') center / cover`,
  },
}))`
  flex: 0 0 4rem;
  border-radius: var(--border-radius-card);
  width: 4rem;
  height: 4rem;
  margin-right: 0.6rem;
`

const CatalogIcon = styled.img`
  height: 1.5rem;
  width: 1.5rem;
`

const ItemTitle = styled.h3`
  font-size: 0.875rem;
  font-weight: var(--font-weight-bold);
  color: var(--color-primary);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin: 0;
  margin-bottom: 4px;
`

const ItemDescription = styled.p`
  font-size: 0.625rem;
  font-weight: var(--font-weight-bold);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin: 0;
  margin-bottom: 6px;
`

const ValidTill = styled.p`
  font-size: 0.625rem;
  font-weight: var(--font-weight-bold);
  color: #9b9b9b;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin: 0;
`

const BlankContainer = styled.div`
  text-align: center;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px;
  box-sizing: border-box;
`

const StyledLoader = styled.img.attrs({ src: Loader })`
  max-height: 30px;
`

const DetailPageContainer = styled.div`
  display: ${props => (props.show ? 'block' : 'none')};
  background-color: inherit;
  transition-property: width;
  transition-duration: var(--animation-duration);
  transition-timing-function: var(--animation-linear);
  overflow: auto;
  height: 100vh;
`

const ErrorPageContainer = styled(DetailPageContainer)`
  display: flex;
  flex-direction: column;
  overflow: unset;
`

const DetailPageContent = styled.div`
  flex: 1 1 auto;
  padding: 2rem 1.125rem;
  position: relative;
`

const Iframe = styled.iframe`
  width: 100%;
  background: #ffffff;
  margin-top: -3.75rem;
  border: 1px solid #ebebeb;
  border-radius: var(--border-radius-card);
  overflow: hidden;

  min-height: calc(100vh - 290px);
`

const SubTitle = styled.h5`
  font-size: 1rem;
  margin: 0;
  margin-bottom: 1rem;
`

const StyledActiveLinkButton = styled(LinkButton)`
  border: 1px solid #5bbdaf;
  border-radius: 4px;
  color: #fff !important;
  background-color: #5bbdaf;
  text-transform: uppercase;
  width: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 0;
  padding-right: 0;
  cursor: pointer;
  font-size: 13px;

  &:hover {
    color: #fff;
    background-color: #5bbdaf;
  }
`
const GCashActionButton = styled(ActionButton)`
  margin-top: 1rem;
  font-size: 13.5px;
  cursor: pointer;
  // background-size: 2rem;
  // background-repeat: no-repeat;
  // background-position: 7.5%;
  background-color: #067dff !important;
  // background-image: url(${GCashV2});
  border-color: #067dff;
  width: 100%;
  color: #fff !important;
  font-weight: var(--font-weight-boldest);
  padding: 10px 0;

  &:hover {
    // background-size: 1.5rem;
    // color: #067dff !important;
    // background-color: #fff;
    border-color: #067dff;
  }
`
const GCashLogo = styled.img`
  height: 17.5px;
  margin-bottom: -4px;
  margin-left: 0.25rem;
`

const GCashWordContainer = styled.img`
  height: 12.5px;
  margin-bottom: -2px;
  margin-left: -1px;
  margin-right: 0.25rem;
`

const DEFAULT_TAB = 'active'

class VouchersPage extends React.Component {
  state = {
    currentTab: DEFAULT_TAB,
    activeTabLoadingStatus: null,
    usedTabLoadingStatus: null,
    selectedVoucher: null,
    selectedVoucherStatus: null,
    loadOnClose: false,
    activeVouchersError: null,
    usedVouchersError: null,
    showGCAshModal: false,
    gCashData: {},
  }

  componentDidMount() {
    const {
      profileDetailPage,
      setProfileModalDetailPage,
      accessToken,
    } = this.props

    // if (accessToken) this.loadGCash()

    if (profileDetailPage) {
      this.setState({
        selectedVoucher: profileDetailPage,
        loadOnClose: true,
      })
      setProfileModalDetailPage(null)
    } else {
      this.setCurrentTab(DEFAULT_TAB)
    }
  }

  showDetailPage = data => {
    this.setState({
      selectedVoucher: data,
    })
  }

  closeDetailPage = () => {
    const { loadOnClose, currentTab } = this.state

    if (loadOnClose) {
      this.setState({
        loadOnClose: false,
      })

      if (currentTab === 'active') {
        this.getActiveLoyalty()
      } else if (currentTab === 'used') {
        this.getUsedLoyalty()
      }
    }

    this.setState({
      selectedVoucher: null,
    })
  }

  setCurrentTab = async tab => {
    this.setState({
      currentTab: tab,
    })

    if (tab === 'active') {
      await this.getActiveLoyalty()
    } else if (tab === 'used') {
      await this.getUsedLoyalty()
    }
  }

  getActiveLoyalty = async () => {
    this.setState({
      activeTabLoadingStatus: 0,
      activeVouchersError: null,
    })

    const { accessToken, setActiveVouchers } = this.props
    try {
      const activeResponse = await LoyaltyApiService.getAllLoyaltyVouchers({
        active: true,
        accessToken,
      })
      setActiveVouchers(activeResponse.data)

      this.setState({
        activeTabLoadingStatus: 1,
      })
    } catch (error) {
      const { data = {} } = error.response || {}
      const { message = 'Network Error' } = data || {}

      this.setState({
        activeTabLoadingStatus: 4,
        activeVouchersError: message,
      })
    }
  }

  getUsedLoyalty = async () => {
    this.setState({
      usedTabLoadingStatus: 0,
      usedVouchersError: null,
    })

    const { accessToken, setUsedVouchers } = this.props

    try {
      const activeResponse = await LoyaltyApiService.getAllLoyaltyVouchers({
        active: false,
        accessToken,
      })
      setUsedVouchers(activeResponse.data)

      this.setState({
        usedTabLoadingStatus: 1,
      })
    } catch (error) {
      const { data = {} } = error.response || {}
      const { message = 'Network Error' } = data || {}

      this.setState({
        usedTabLoadingStatus: 4,
        usedVouchersError: message,
      })
    }
  }

  // loadGCash = async () => {
  //   const { accessToken } = this.props
  //   try {
  //     const { data: gCashData } = await GCashApiService.getGCashStatus(
  //       accessToken,
  //     )
  //     this.setState({ gCashData })
  //   } catch (err) {
  //     this.setState({
  //       errorMessage: 'Unable to Retrieve GCash Data',
  //     })
  //   }
  // }

  // linkGCash = async () => {
  //   const { setProfileModalPage } = this.props
  //   const { accessToken } = this.props

  //   try {
  //     const { data: gCashData } = await GCashApiService.linkGCash(accessToken)

  //     this.setState({ showGCAshModal: false, gCashData })
  //   } catch (err) {
  //     this.setState({
  //       showGCAshModal: false,
  //       errorMessage: 'Unable to request GCash Linking',
  //     })
  //   }
  //   setProfileModalPage(MAIN)
  // }

  // unLinkGCash = async () => {
  //   const { accessToken } = this.props

  //   try {
  //     const { data: gCashData } = await GCashApiService.linkGCash(accessToken)

  //     this.setState({ showGCAshModal: false, gCashData })
  //   } catch (err) {
  //     this.setState({
  //       showGCAshModal: false,
  //       errorMessage: 'Unable to request GCash Unlinking',
  //     })
  //   }
  // }

  toggleGCashModal = () => {
    this.setState({ showGCAshModal: !this.state.showGCAshModal })
  }

  changeNumber = () => {
    const { setProfileModalPage } = this.props
    setProfileModalPage(UPDATE_PROFILE)
  }

  handleGCashButton = () => {
    const { setProfileModalPage } = this.props
    const { gCashData } = this.state
    const { status } = gCashData
    if (status === gCashStatus.noRequest) this.toggleGCashModal()
    else setProfileModalPage(MAIN)
  }

  render() {
    const {
      currentTab,
      activeTabLoadingStatus,
      usedTabLoadingStatus,
      selectedVoucher,
      activeVouchersError,
      usedVouchersError,
      showGCAshModal,
      gCashData,
    } = this.state
    const {
      setProfileModalPage,
      activeVouchers,
      usedVouchers,
      advanceAccount,
      displayProfileModal,
      primaryInfo,
    } = this.props
    const { mobileNumber } = primaryInfo || {}

    const TabContent = ({ tabData, tabLoading }) => (
      <>
        {tabLoading === 0 && (
          <BlankContainer>
            <StyledLoader />
          </BlankContainer>
        )}
        {tabLoading === 1 &&
          tabData.map(props => (
            <ListItem key={props.id} onClick={() => this.showDetailPage(props)}>
              <ItemIcon
                background={!!props.merchant && props.merchant.imageUrl}
              />
              <DetailWrapper>
                <ItemTitle>{props.title}</ItemTitle>
                <ItemDescription>
                  {!!props.merchant && props.merchant.name}
                </ItemDescription>
                <ValidTill>Valid until {dateFormat(props.expiryAt)}</ValidTill>
              </DetailWrapper>
              <CatalogIcon src={props.catalogIconUrl} />
            </ListItem>
          ))}
        {tabLoading === 1 &&
          tabData.length === 0 &&
          (!activeVouchersError || !usedVouchersError) && (
            <BlankContainer>
              <p>
                Explore the Zing app
                <br /> for more perks and benefits!
              </p>

              {/* {advanceAccount && advanceAccount.advanced ? (
              ST-7046 - Rewards :: Advanced : Remove Rewards Page
                <StyledActiveLinkButton
                  to="/rewards"
                  onClick={() => displayProfileModal(false)}
                >
                  Browse Rewards Catalog
                </StyledActiveLinkButton>
              ) : (
                <>
                  <StyledActiveLinkButton
                    onClick={() => {
                      setProfileModalPage(ADD_CARD)
                    }}
                  >
                    Link Card Now
                  </StyledActiveLinkButton>



                  ST-7034 - [Web] Profile :: My Vouchers - Basic : Update Copy and Remove Gcash Linking Button
                  <GCashActionButton onClick={this.handleGCashButton}>
                    <div>
                      Link
                      <GCashLogo src={GCashV2} alt={'gcash logo'} />
                      <GCashWordContainer src={GCashWord} alt={'gcash'} />
                      Now
                    </div>
                  </GCashActionButton>
                </>
              )} */}
            </BlankContainer>
          )}
        {tabLoading === 4 &&
          tabData.length === 0 &&
          (activeVouchersError || usedVouchersError) && (
            <BlankContainer>Unable to Retrieve Data</BlankContainer>
          )}
      </>
    )

    const DetailPage = ({ data }) => {
      const show = !!data
      const { merchant, redeemUrl, status } = data || {}

      const { name: merchantName, imageUrl, tagLine } = merchant || {}

      if (status === 2) {
        return (
          <Slide right duration={200}>
            <ErrorPageContainer show={show}>
              {!!show && (
                <>
                  <ErrorHeader>
                    <ReturnIcon onClick={this.closeDetailPage}>
                      <Icon name="slide-left" />
                    </ReturnIcon>
                    <Title>Voucher Expired</Title>
                  </ErrorHeader>
                  <DetailPageContent>
                    <SubTitle style={{ textAlign: 'center' }}>
                      This voucher has already expired.
                    </SubTitle>
                  </DetailPageContent>
                </>
              )}
            </ErrorPageContainer>
          </Slide>
        )
      }

      return (
        <Slide right duration={200}>
          <DetailPageContainer show={show}>
            {!!show && (
              <>
                <DetailHeader background={imageUrl}>
                  <DetailReturnIcon onClick={this.closeDetailPage}>
                    <Icon name="slide-left" />
                  </DetailReturnIcon>
                  <HeaderDetails>
                    <Merchant>{merchantName}</Merchant>
                    <TagLine>{tagLine}</TagLine>
                  </HeaderDetails>
                </DetailHeader>
                <DetailPageContent>
                  <Iframe
                    src={redeemUrl}
                    onLoad={e => {
                      try {
                        const iFrame = e.currentTarget
                        iFrame.style.height = `${iFrame.contentWindow.document.body.scrollHeight}px`
                      } catch (error) {}
                    }}
                  />
                </DetailPageContent>
              </>
            )}
          </DetailPageContainer>
        </Slide>
      )
    }

    return (
      <>
        <MainPage show={!selectedVoucher}>
          <Header>
            <ReturnIcon onClick={() => setProfileModalPage(MAIN)}>
              <Icon name="slide-left" />
            </ReturnIcon>
            <Title>My Vouchers</Title>
          </Header>
          <TabWrapper>
            <Tab
              active={currentTab === 'active'}
              onClick={() => {
                this.setCurrentTab('active')
              }}
            >
              Active Vouchers
            </Tab>
            <Tab
              active={currentTab === 'used'}
              onClick={() => {
                this.setCurrentTab('used')
              }}
            >
              Used Vouchers
            </Tab>
          </TabWrapper>
          <Content>
            {currentTab === 'active' && (
              <TabContent
                tabData={activeVouchers}
                tabLoading={activeTabLoadingStatus}
              />
            )}
            {currentTab === 'used' && (
              <TabContent
                tabData={usedVouchers}
                tabLoading={usedTabLoadingStatus}
              />
            )}
          </Content>
        </MainPage>
        <DetailPage data={selectedVoucher} />
        {/* <GCashModal
          show={showGCAshModal}
          zIndex={10025}
          gCashData={gCashData}
          onLink={this.linkGCash}
          onClose={this.toggleGCashModal}
          mobileNumber={mobileNumber}
          onChangeNumber={this.changeNumber}
        /> */}
      </>
    )
  }
}

VouchersPage.defaultProps = {
  activeVouchers: [],
  usedVouchers: [],
}

VouchersPage.propTypes = {
  activeVouchers: PropTypes.array,
  usedVouchers: PropTypes.array,
}

export default VouchersPage
